import type { FC } from 'react';

import { CONTACT } from '@/constants/site.constants';
import { SECTION_IDS } from '@/features/home/constants/home.constants';
import type { StoreBadge } from '@/types/home.types';

interface DownloadCtaProps {
  badges: StoreBadge[];
}

const badgeClasses =
  'flex min-w-[210px] items-center gap-3 rounded-2xl border border-white/15 bg-white/10 px-5 py-3 text-left';

const DownloadCta: FC<DownloadCtaProps> = ({ badges }) => (
  <section id={SECTION_IDS.download} className="scroll-mt-20 bg-white pb-20">
    <div className="mx-auto w-full max-w-6xl px-5 md:px-8">
      <div className="flex flex-col items-center gap-8 rounded-[32px] bg-brand-700 px-6 py-16 text-center md:px-16">
        <h2 className="max-w-2xl font-display text-3xl font-extrabold text-white md:text-4xl">
          Get Shoutt on your campus
        </h2>
        <p className="max-w-xl text-base leading-relaxed text-white/70">
          The apps are in the final stretch. Tell us which college you’re at and we’ll open it there
          first.
        </p>

        <div className="flex flex-col gap-3 sm:flex-row">
          {badges.map((badge) =>
            badge.href ? (
              <a
                key={badge.platform}
                href={badge.href}
                className={`${badgeClasses} transition-colors hover:bg-white/20`}
              >
                <span>
                  <span className="block text-[11px] tracking-wide text-white/60 uppercase">
                    Download on
                  </span>
                  <span className="block font-display text-base font-bold text-white">
                    {badge.storeName}
                  </span>
                </span>
              </a>
            ) : (
              <div key={badge.platform} className={`${badgeClasses} opacity-70`} aria-disabled>
                <span>
                  <span className="block text-[11px] tracking-wide text-white/60 uppercase">
                    {badge.prefix}
                  </span>
                  <span className="block font-display text-base font-bold text-white">
                    {badge.storeName}
                  </span>
                </span>
              </div>
            ),
          )}
        </div>

        <a
          href={`mailto:${CONTACT.email}?subject=Bring%20Shoutt%20to%20my%20campus`}
          className="text-sm font-semibold text-white underline underline-offset-4 transition-colors hover:text-white/80"
        >
          Bring Shoutt to my campus
        </a>
      </div>
    </div>
  </section>
);

export default DownloadCta;
